export const CURRENCIES = [
  { symbol: "€", code: "EUR" },
  { symbol: "$", code: "USD" },
  { symbol: "₴", code: "UAH" },
  // { symbol: "L", code: "MDL" },
]

export const formatMoney = (amount, currency) => {
  if (amount === null || amount === undefined || amount === "" || isNaN(amount)) {
    return "0,0"
  }

  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: currency,
  }).format(Number(amount))
}
